import type { VatCodeDto } from "../../types/VatCodeDto";
import type { VatCodeEntity } from "../../types/VatCodeEntity";

export const VatCodeDtoToEntity = ({ ...rest }: Readonly<VatCodeDto>): VatCodeEntity => {
    return { ...rest };
};
